export default __webpack_public_path__ + "static/media/Che.9665a3b1.png";